import { useState } from 'react'
import { Modal, Button, Form, Row, Col, Alert } from 'react-bootstrap'
import moment from 'moment'
import validateNRIC from '../lib/validateNRIC'
import { useTranslation } from 'react-i18next'

export const PdpaAlertModal = ({ show, setShowModal, job, setShowPdpaForm }) => {
	const { t } = useTranslation()

	return (
		<>
			<Modal 
				show={show} 
				onHide={() => { setShowModal(false) }}
			>
				<Modal.Header closeButton>
					<Modal.Title>{t('pdpa_modal.notice')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{job.Event !== null && <p>{t('pdpa_modal.by_proceeding_to_apply')}<strong>{job.Event.yellowFormCollector === null ? 'e2i' : job.Event.yellowFormCollector}</strong>{t('pdpa_modal.reporting_purpose')}<a target='_blank' rel='noreferrer' href={job.Event.yellowFormPdpaUrl === null ? 'https://e2i.com.sg/pdpa' : job.Event.yellowFormPdpaUrl}>{t('pdpa_modal.our_pdpa_policy')}</a></p>}
					{job.Event === null && <p>{t('pdpa_modal.by_proceeding_to_apply')}{t('pdpa_modal.reporting_purpose')}<a target='_blank' rel='noreferrer' href='https://e2i.com.sg/pdpa'>{t('pdpa_modal.our_pdpa_policy')}</a></p>}
				</Modal.Body>
				<Modal.Footer>
					<Button variant='secondary' onClick={() => { setShowModal(false) }}>
						{t('pdpa_modal.close')}
					</Button>
					<Button variant='primary' className='text-white' onClick={() => { setShowPdpaForm(true); setShowModal(false) }}>
						{t('pdpa_modal.agree')}
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	)
}


export const PdpaFormModal = ({ show, setShowPdpaForm, pdpaData, setPdpaData, showNSField, address, addressInvalid, client, profile, applyingJob }) => {
	const { t } = useTranslation()
	const [nricNotValid, setNricNotValid] = useState(false)
	const [errorSavePdpa, setErrorSavePdpa] = useState<boolean>(false)
	const [formNotComplete, setFormNotComplete] = useState<boolean>(false)
	const [dateOfUnemploymentErr, setDateOfUnemployment] = useState<boolean>(false)
	
	const submitPdpa = (e: any): void => {
		e.preventDefault()
		e.stopPropagation()

		const addressObj = {
			postalCode: address.postalCode,
			streetAddress: address.streetAddress,
			location: address.location,
			blockNumber: pdpaData.blockNumber,
			unit: pdpaData.unit
		}

		if (!nricNotValid) {
			client.query({
				query: `
          mutation($obj: [Address_insert_input!]!) {
            insert_Address(objects: $obj) {
              affected_rows
              returning {
                id
              }
            }
          }
        `,
				variables: {
					obj: addressObj
				}
			}).then(({ data: { insert_Address: { returning } } }: any) => {
				const addressId: number = returning[0].id
				client.query({
					query: `
            mutation {
              update_Applicant_by_pk(pk_columns: {id: ${profile.id as number}}, _set: {
                address: ${addressId}
                name: "${pdpaData.name}"
                nric: "${pdpaData.nric}"
                race: "${pdpaData.race}"
                dateOfBirth: "${pdpaData.dateOfBirth}"
                nsStatus: ${(pdpaData.nsStatus === '' || pdpaData.nsStatus === null) ? null : `"${pdpaData.nsStatus}"`}
                ${(pdpaData.dateOfUnemployment === '' || pdpaData.dateOfUnemployment === null) ? '' : `unemploymentDate: "${pdpaData.dateOfUnemployment}"`}
              }) {
                id
              }
            }
          `
				}).then(() => {
					setShowPdpaForm(false)
					applyingJob()
					// router.push(`/job/${slugify(job.title)}-${job.id as string}/apply`).catch(err => console.error(err))
				}).catch(() => {
					setErrorSavePdpa(true)
					// console.error(err)
				})
			})
		} else {
			setFormNotComplete(true)
		}
	}

	return (
		<Modal 
			show={show} 
			onHide={() => { setShowPdpaForm(false) }}
		>
			<Form onSubmit={submitPdpa}>
				<Modal.Header closeButton>
					<Modal.Title>{t('pdpa_modal.you_only_need_to_fill_once')}</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ padding: '30px' }}>
					{formNotComplete && <Alert variant='danger'>{t('pdpa_modal.you_must_complete_the_form')}</Alert>}
					{errorSavePdpa && <Alert variant='danger'>{t('pdpa_modal.there_is_an_error')}</Alert>}
					<Form.Group className='mb-3'>
						<Form.Label>{t('pdpa_modal.full_name')}</Form.Label>
						<Form.Control
							type='text'
							placeholder={t('pdpa_modal.enter_your_full_name')}
							required
							value={pdpaData.name}
							onChange={event => {
								setPdpaData({
									...pdpaData,
									name: event.target.value
								})
							}}
						/>
					</Form.Group>

					<Form.Group className='mb-3'>
						<Form.Label>{t('pdpa_modal.nric')}</Form.Label>
						<Form.Control
							type='text'
							placeholder={t('pdpa_modal.enter_nric')}
							required
							value={pdpaData.nric}
							onChange={event => {
								setPdpaData({
									...pdpaData,
									nric: event.target.value
								})
								setNricNotValid(!validateNRIC(event.target.value))
							}}
						/>
						{nricNotValid &&
									<Form.Text className='text-danger'>
										{t('pdpa_modal.enter_a_valid_nric')}
									</Form.Text>}
					</Form.Group>

					<Form.Group className='mb-3'>
						<Form.Label>{t('pdpa_modal.address')}</Form.Label>
						<Form.Control
							type='number'
							placeholder={t('pdpa_modal.enter_postal_code')}
							required
							value={pdpaData.address}
							onChange={event => {
								setPdpaData({
									...pdpaData,
									address: event.target.value
								})
							}}
						/>
						{addressInvalid &&
									<Form.Text className='text-danger'>
										{t('pdpa_modal.enter_a_valid_postal_code')}
									</Form.Text>}
						{address.streetAddress !== '' &&
									<Form.Control readOnly type='text' style={{ marginTop: '12px' }} value={address.streetAddress} />}
					</Form.Group>
					<Row style={{ marginBottom: '14px', marginTop: '-5px' }}>
						<Col>
							<Form.Control
								type='number'
								placeholder={t('pdpa_modal.enter_block_number')}
								value={pdpaData.blockNumber}
								onChange={event => {
									setPdpaData({
										...pdpaData,
										blockNumber: event.target.value
									})
								}}
							/>
						</Col>
						<Col>
							<Form.Control
								type='text'
								placeholder={t('pdpa_modal.enter_unit_number')}
								value={pdpaData.unit}
								onChange={event => {
									setPdpaData({
										...pdpaData,
										unit: event.target.value
									})
								}}
							/>
						</Col>
					</Row>

					<Form.Group className='mb-3'>
						<Form.Label>{t('pdpa_modal.date_of_unemployment')}</Form.Label>
						<Form.Control
							type='date'
							placeholder={t('pdpa_modal.enter_date_unemployment')}
							value={pdpaData.dateOfUnemployment}
							onChange={event => {
								if (new Date(event.target.value) < new Date()) {
									setPdpaData({
										...pdpaData,
										dateOfUnemployment: event.target.value
									})
								} else {
									setDateOfUnemployment(true)
									setPdpaData({
										...pdpaData,
										dateOfUnemployment: ''
									})
								}
							}}
						/>
						{dateOfUnemploymentErr &&
									<Form.Text className='text-warning'>{t('pdpa_modal.select_date_earlier')}</Form.Text>}
					</Form.Group>

					<Form.Group className='mb-3'>
						<Form.Label>{t('pdpa_modal.dob')}</Form.Label>
						<Form.Control
							type='date'
							placeholder={t('pdpa_modal.enter_dob')}
							required
							min='1921-01-01'
							max={moment().subtract(16, 'years').format('YYYY-MM-DD')}
							value={pdpaData.dateOfBirth}
							onChange={event => {
								setPdpaData({
									...pdpaData,
									dateOfBirth: event.target.value
								})
							}}
						/>
					</Form.Group>

					<Form.Group className='mb-3'>
						<Form.Label>{t('pdpa_modal.race')}</Form.Label>
						<Form.Control
							as='select'
							required
							value={pdpaData.race}
							onChange={event => {
								setPdpaData({
									...pdpaData,
									race: event.target.value
								})
							}}
						>
							<option value=''>{t('pdpa_modal.select_race')}</option>
							<option value='CHINESE'>Chinese</option>
							<option value='MALAY'>Malay</option>
							<option value='INDIAN'>Indian</option>
							<option value='OTHERS'>Others</option>
						</Form.Control>
					</Form.Group>

					{showNSField && (
						<Form.Group className='mb-3'>
							<Form.Label>{t('pdpa_modal.national_service_status')}</Form.Label>
							<Form.Control
								as='select'
								required
								value={pdpaData.nsStatus}
								onChange={event => {
									setPdpaData({
										...pdpaData,
										nsStatus: event.target.value
									})
								}}
							>
								<option value=''>{t('pdpa_modal.select_status')}</option>
								<option value='YET TO BE ENLISTED'>{t('pdpa_modal.yet_to_be_enlisted')}</option>
								<option value='COMPLETED'>{t('pdpa_modal.completed')}</option>
								<option value='YET TO COMPLETE'>{t('pdpa_modal.yet_to_complete')}</option>
								<option value='EXEMPTED'>{t('pdpa_modal.exempted')}</option>
							</Form.Control>
						</Form.Group>
					)}

				</Modal.Body>
				<Modal.Footer>
					<Button variant='primary' type='submit' className='text-white'>
						{t('pdpa_modal.submit')}
					</Button>
				</Modal.Footer>
			</Form>
		</Modal>
	)
}
